import { useState } from 'react';
import tw, { styled } from 'twin.macro';

import CandidateStateUpdateSuccess from '../candidate-state-update-success';
import DiscardCandidateReason, { DiscardCandidateSteps } from './discard-candidate-reason';

function DiscardCandidate({ firstName, jobPositionId, workerId, onClose }: CandidateInterviewProps) {
  const [discardCandidateStep, setDiscardCandidateStep] = useState(DiscardCandidateSteps.INPUT_REASON);

  return (
    <MainWrapper>
      <InnerWrapper>
        {discardCandidateStep === DiscardCandidateSteps.VIEW_SUCCESS_MESSAGE ? (
          <CandidateStateUpdateSuccess onClose={onClose} isDiscarded />
        ) : (
          <DiscardCandidateReason
            firstName={firstName}
            setStep={setDiscardCandidateStep}
            step={discardCandidateStep}
            jobPositionId={jobPositionId}
            workerId={workerId}
          />
        )}
      </InnerWrapper>
    </MainWrapper>
  );
}
export default DiscardCandidate;

const MainWrapper = styled.div`
  ${tw`w-full`}
`;
const InnerWrapper = styled.div`
  ${tw`max-w-screen-sm p-4 mx-auto flex flex-col justify-between md:(h-[calc(100vh - 150px)] py-10 px-12) text-center`}
`;

interface CandidateInterviewProps {
  firstName: string;
  jobPositionId: string;
  workerId: string;
  onClose: () => void;
}
